import script from "./ShopItemAction.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopItemAction.vue?vue&type=script&lang=ts&setup=true"

import "./ShopItemAction.vue?vue&type=style&index=0&id=bbceb348&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbceb348"]])

export default __exports__